"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const ModalBase_1 = __importDefault(require("../ModalBase/ModalBase"));
const ModalContent_1 = __importDefault(require("../ModalContent/ModalContent"));
const ProductImage_1 = __importDefault(require("../ProductImage/ProductImage"));
const ProductSummary_1 = __importDefault(require("../ProductSummary/ProductSummary"));
const ProductDetails_1 = __importDefault(require("../ProductDetails/ProductDetails"));
const ProductCTA_1 = __importDefault(require("../ProductCTA/ProductCTA"));
const handleTag_1 = __importDefault(require("../../utils/handleTag"));
/**
 * Common wrapper for the most common detail modal layout if you dont need to extend
 * or modify the components used
 *
 * @param {object} props
 *
 * @param {boolean} props.isOpen
 * @param {function} props.closeHandler
 * @param {string} props.imgixURL - Imgix url domain, normally set up in env variables for each app
 * @param {import('react').ReactNode} props.buystack - React node that contains the buystack components to render, is slotted under the product details
 * @param {import('../../typedefs').Product} props.productData
 * @param {{
 *  useProductData: import('../../typedefs').UseProductData,
 *  useProductState: import('../../typedefs').UseProductState
 * }} props.selectionDeps
 * @param {{
 *  useGetDiscounts: import('../../typedefs').UseGetDiscounts
 *  applyDiscounts: import('../../typedefs').ApplyDiscounts
 * }} props.promotionDeps
 * @param {object} props.modalContainerProps
 * @param {boolean} props.hideStrikethrough
 */
const DetailModal = ({ isOpen, closeHandler, imgixURL, productData, buystack, selectionDeps, promotionDeps, modalContainerProps, hideStrikethrough = false }) => {
    if (!productData)
        return null;
    const productTag = (0, handleTag_1.default)(productData.isNew, productData.tag);
    return (0, jsx_runtime_1.jsx)(ModalBase_1.default, { isOpen: isOpen, closeHandler: closeHandler, ...modalContainerProps, children: (0, jsx_runtime_1.jsx)(ModalContent_1.default, { main: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProductImage_1.default, { productCode: productData.productCode, selectionDeps: selectionDeps, IMGIX_URL: imgixURL, alt: `Image for ${productData.productCode}`, tag: productTag }), (0, jsx_runtime_1.jsx)(ProductSummary_1.default, { promotionDeps: promotionDeps, selectionDeps: selectionDeps, title: productData.title, subtitle: productData.subtitle, tooltip: productData.tooltip, product: { ...productData }, selectedSizes: productData.selectedSizes, hideStrikethrough: hideStrikethrough })] }), content: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProductDetails_1.default, { details: productData.details }), buystack] }), footer: (0, jsx_runtime_1.jsx)(ProductCTA_1.default, { selectionDeps: selectionDeps, productCode: productData.productCode, showLearnMoreCta: productData.hasLearnMoreCta, shopCta: productData.shopCta, compareCta: productData.compareCta }) }) });
};
DetailModal.propTypes = {
    isOpen: prop_types_1.default.bool.isRequired,
    closeHandler: prop_types_1.default.func.isRequired,
    imgixURL: prop_types_1.default.string.isRequired,
    productData: prop_types_1.default.object,
    buystack: prop_types_1.default.node,
    selectionDeps: prop_types_1.default.shape({
        useProductState: prop_types_1.default.func.isRequired,
        useProductData: prop_types_1.default.func.isRequired
    }).isRequired,
    promotionDeps: prop_types_1.default.shape({
        useGetDiscounts: prop_types_1.default.func.isRequired,
        applyDiscounts: prop_types_1.default.func.isRequired
    }),
    modalContainerProps: prop_types_1.default.object,
    hideStrikethrough: prop_types_1.default.bool
};
exports.default = DetailModal;
//# sourceMappingURL=DetailModal.js.map